interface Window {
    sessionTrackerHelper?: (sessionTrackerHelper) => void;
}

window.sessionTrackerHelper = (): object => {
    "use strict";

    const delimiter = "|";
    const memberCookieName = "member-id";
    const memberIdCookiesComponent = {
        "guestmemberid": 0,
        "encrpyteduserid": 1,
        "isloggedin": 2,
        "cookiereneweddate": 3
    };

    return {
        getCookie: (cookieName): string => {
            const match = document.cookie.match(new RegExp("(^| )" + cookieName + "=([^;]+)"));
            if (match) return match[2];
            return "";
        },

        getComponentFromMemberCookie: function (memberIdComponent): string {
            const memberIdCookie = decodeURI(this.getCookie(memberCookieName));
            if (memberIdCookie === "") {
                return "";
            }
            const trackingCookies = memberIdCookie.split(delimiter);
            if (trackingCookies === null || trackingCookies === undefined || trackingCookies.length !== 4) {
                return "";
            }
            return trackingCookies[memberIdComponent];
        },

        getSessionIdFromUserCookie: function (): string {
            return this.getComponentFromMemberCookie(memberIdCookiesComponent.guestmemberid);
        },

        getEncryptedUserIdFromUserCookie: function () {
            const isLoggedIn = this.getComponentFromMemberCookie(memberIdCookiesComponent.isloggedin) === "1";
            if (isLoggedIn) {
                return this.getComponentFromMemberCookie(memberIdCookiesComponent.encrpyteduserid);
            }
            return "";
        }
    };
};
